<template>
  <v-app>
    <v-main>
      <!-- Logo Section -->
      <v-container>
        <v-row justify="center" >
          <v-col cols="12" class="text-center">
            <img src="@/assets/sastraLogo.png" alt="Sastra Logo" class="logo" />
          </v-col>
        </v-row>

        <!-- University Info Section -->
        <v-row justify="center" no-gutters>
          <v-col cols="12" class="text-center">
            <span class="font-weight-bold caption d-block">
              DIRECTORATE OF ONLINE AND DISTANCE EDUCATION
            </span>
            <span class="text-caption d-block">
              SASTRA DEEMED UNIVERSITY, Tamil Nadu, 613401
            </span>
            <span class="text-caption d-block">
              Landline Number: 04423650027
            </span>
            <span class="text-caption d-block">
              Website:
              <a href="https://dde.sastra.edu/" target="_blank">
                https://dde.sastra.edu/
              </a>
            </span>
            <span class="text-caption d-block">
              Email:
              <a href="mailto:admissionsol@dde.sastra.ac.in">
                admissionsol@dde.sastra.ac.in
              </a>
            </span>
          </v-col>
        </v-row>
      </v-container>

      <!-- Dynamic Page Content -->
      <router-view />
    </v-main>
    <v-snackbar
      :timeout="$store.state.snackbar.timeout"
      top
      right
      :color="$store.state.snackbar.color"
      v-model="$store.state.snackbar.show"
    >
      <strong>{{ $store.state.snackbar.message }}</strong>
      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          dark
          text
          v-bind="attrs"
          id="clear_notification"
          @click="hideSnackbar"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
  methods: {
    hideSnackbar() {
      this.$store.commit("hideSnackbar");
    },
  },
};
</script>
<style scoped>
.logo {
  height: 45px;
  max-width: 280px;
  width: 100%; /* Ensures responsiveness */
  object-fit: contain; /* Prevents cropping */
}
</style>
